import { render, staticRenderFns } from "./brochureDetailDialog.vue?vue&type=template&id=44229d4e&scoped=true"
import script from "./brochureDetailDialog.vue?vue&type=script&lang=js"
export * from "./brochureDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./brochureDetailDialog.vue?vue&type=style&index=0&id=44229d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44229d4e",
  null
  
)

export default component.exports